/**
 * Service registry with specific getter functions
 * Server-side only - uses Traefik routing
 */
export const AUTH_SERVICE_NAME = "auth";
export const TRANSLATOR_SERVICE_NAME = "translator";

export type Namespace = "auth" | "translator" | "users";
// composables/useServiceRegistry.ts
export const useServiceRegistry = () => {
  const config = useRuntimeConfig();

  const getServiceUrl = (options: {
    serviceHost: string;
    namespace: string;
  }): string => {
    const { serviceHost, namespace } = options;
    const url = `${config?.public?.[serviceHost] || config?.public?.[serviceHost]}${config?.public[namespace] || ""}`;
    if (!url) {
      throw new Error(`Service "${serviceHost}" not configured`);
    }

    return url as string;
  };

  return {
    getAuthServiceUrl: () =>
      getServiceUrl({
        serviceHost: "authServiceUrl",
        namespace: "authNamespaceAuth",
      }),
    getAuthUserServiceUrl: () =>
      getServiceUrl({
        serviceHost: "authServiceUrl",
        namespace: "authNamespaceUser",
      }),
    getTranslatorServiceUrl: () =>
      getServiceUrl({
        serviceHost: "authServiceUrl",
        namespace: "translator",
      }),
  };
};
